var map = {
	"./1coussin.webp": 4680,
	"./2Lalie-Design-Piccolo.webp": 104,
	"./3coussin.webp": 3300,
	"./4coussin.webp": 7746,
	"./5coussin.webp": 5608,
	"./6coussin.webp": 4400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4911;